import type { Salutation } from "./SalutationField";

export const SALUTATIONS_DICTIONARY: Record<string, Salutation[]> = {
    "de-DE": [
        { name: "Herr", value: "Herr" },
        { name: "Frau", value: "Frau" },
    ],
};
